function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}import styles from './editable-tracked.scss';
import template from './editable-tracked.html';

export var EditableTrackedComponent = {
  template: template,
  bindings: {
    index: "<",
    viewValue: "<",
    timeValue: "<",
    unit: "@",
    onSave: "&" },

  controller: ["$timeout", "$filter",
  function EditableTrackedComponentController($timeout, $filter) {
    "ngInject";var _this = this;_classCallCheck(this, EditableTrackedComponentController);
    console.log(this);
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.processing = false;
    this.disabled = true;

    this.toggleEditable = function () {return _this.disabled = !_this.disabled;};


    this.handlerSubmit = function () {
      _this.processing = true;
      var result = {
        value: _this.viewValue,
        time: _this.timeValue,
        unit: _this.unit,
        index: _this.index };


      _this.$timeout(function () {
        _this.disabled = true;
        _this.processing = false;
        _this.onSave({ result: result });
      }, 500);
    };
  }] };